import { TYPE_SELL, TYPE_DEBT_SELL, TYPE_PURCHASE, TYPE_RETURN_SELL, TYPE_RETURN_PURCHASE, TYPE_CHANGES_IN, TYPE_CHANGES_OUT, TYPE_MOVING, TYPE_CHANGES_INVENTORY } from './const.js'

let order_type_labels = {
  [TYPE_SELL]: "Продажа",
  [TYPE_DEBT_SELL]: "Продажа в долг",
  [TYPE_PURCHASE]: "Закупка",
  [TYPE_RETURN_SELL]: "Возврат продажи",
  [TYPE_RETURN_PURCHASE]: "Возврат закупки",
  [TYPE_CHANGES_INVENTORY]: "Инвентаризация",
  [TYPE_CHANGES_IN]: "Оприходование",
  [TYPE_CHANGES_OUT]: "Списание",
  [TYPE_MOVING]: "Перемещение"
};
export {order_type_labels};



// WEBPACK FOOTER //
// ./src/apps/product_order/order_type_list.js